import type { JSX } from 'react'

export interface SearchBoxProps {
  readonly value: string
  readonly onChange: (value: string) => void
  readonly placeholder?: string
  readonly className?: string
  readonly dataTestId?: string
}

/**
 * Global search box component that can be used across the application.
 * Provides consistent search UI with debounced input handling.
 */
export default function SearchBox({
  value,
  onChange,
  placeholder = 'Search...',
  className = '',
  dataTestId = 'search-box',
}: SearchBoxProps): JSX.Element {
  return (
    <div className={`relative ${className}`}>
      <input
        type="text"
        value={value}
        onChange={(e) => { onChange(e.target.value) }}
        placeholder={placeholder}
        data-testid={dataTestId}
        className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
      />
      <svg
        className="absolute left-3 top-1/2 transform -translate-y-1/2 w-4 h-4 text-gray-400"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
        />
      </svg>
    </div>
  )
}
